import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ImageLightbox from '../Services/ImageLightbox';
import { metadata } from '../../mdx/services/drone-photography.mdx';
import './Dronephotos.css';

const Dronephotos = () => {
  const images = metadata.images || [];
  const [selectedIdx, setSelectedIdx] = useState(null);
  const move = (step) => {
    if (!images.length) return;
    setSelectedIdx((current) => (current + step + images.length) % images.length);
  };

  return (
    <section className="dp">
      <div className="dp__container">
        <h2 className="dp__title">Aerial Perspectives</h2>
        <p className="dp__subtitle">Capturing the world from new heights</p>
        <div className="dp__grid">
          {images.map((src, index) => (
            <motion.figure key={src} className="dp__item" initial={{ opacity: 0, y: 80 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} onClick={() => setSelectedIdx(index)}>
              <img src={`${process.env.PUBLIC_URL}${src}`} alt={`Drone perspective ${index + 1}`} loading="lazy" />
              <div className="dp__item-overlay"><span className="dp__item-number">{index + 1}</span></div>
            </motion.figure>
          ))}
        </div>
      </div>
      <ImageLightbox images={images} index={selectedIdx} onClose={() => setSelectedIdx(null)} onChange={move} />
    </section>
  );
};

export default Dronephotos;
